import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateListsTab } from "appRedux/slices/profileTabsSlice"
import { useLazyGetWishListsWithFirstFourItemsQuery, userProfileApi } from "appRedux/slices/userApiSlice"

export default function useWishListsWithFirstFourItems() {
  const role = useAppSelector((state) => state.global.role)
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)

  const cachedWishLists = useAppSelector((state) => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return null
    return userProfileApi.endpoints.getWishListsWithFirstFourItems.select(currentPageInfo?.dynamicPathParts?.handle)(state)
  })

  const [triggerGetWishListsWithFirstFourItems, wishListsWithFirstFourItemsResult] = useLazyGetWishListsWithFirstFourItemsQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    if (cachedWishLists?.data) {
      dispatch(updateListsTab(cachedWishLists.data.wishlists || []))
      return
    }
    fetchWishLists()
  }, [role, currentPageInfo?.dynamicPathParts])

  useEffect(() => {
    if (wishListsWithFirstFourItemsResult?.data) {
      dispatch(updateListsTab(wishListsWithFirstFourItemsResult?.data?.wishlists || []))
    }
  }, [wishListsWithFirstFourItemsResult])

  function fetchWishLists() {
    if (!currentPageInfo?.dynamicPathParts?.handle) return
    triggerGetWishListsWithFirstFourItems(currentPageInfo?.dynamicPathParts?.handle)
  }

  return {
    lists: cachedWishLists?.data?.wishlists || [],
    isFetching: wishListsWithFirstFourItemsResult.isFetching,
    isError: wishListsWithFirstFourItemsResult.isError
  }
}
